import React from 'react';
import { Dropdown, DropdownItem, DropdownMenu } from 'reactstrap';
import { useQueueContentChatContext } from '../../../../../../hooks/useQueueContentChat';

export const FilterStatusOptions = ({
  open,
  openDropDown,
  handlerFilter,
  children
}) => {
  const { filters } = useQueueContentChatContext();

  const handleClick = (option, type, e) => {
    e.stopPropagation();
    handlerFilter(option, type);
  };

  return (
    <Dropdown
      direction="right"
      style={{
        display: 'flex',
        border: 'none',
        margin: 0,
        padding: 0,
        width: '100%',
        height: '100%',
        color: 'black'
      }}
      onMouseEnter={() => openDropDown(true)}
      onMouseLeave={() => openDropDown(false)}
      isOpen={open}
      toggle={() => openDropDown(!open)}
    >
      {children}
      <DropdownMenu
        style={{
          marginLeft: '-10px'
        }}
        className="DropdownMenu"
      >
        <DropdownItem
          toggle={false}
          onClick={(e) => handleClick('ALL', 'STATUS', e)}
        >
          <input
            id={`dropdownItemSTATUS_ALL`}
            type="checkbox"
            checked={filters['STATUS'].length === 0}
            onChange={(e) => handleClick('ALL', 'STATUS', e)}
            style={{ marginRight: '5px' }}
          />
          Todas
        </DropdownItem>
        <DropdownItem divider />
        <DropdownItem
          toggle={false}
          onClick={(e) => handleClick('ANSWERED', 'STATUS', e)}
        >
          <input
            id={`dropdownItemANSWERED`}
            type="checkbox"
            checked={filters['STATUS'] === 'ANSWERED'}
            onChange={(e) => handleClick('ANSWERED', 'STATUS', e)}
            style={{ marginRight: '5px' }}
          />
          Respondidas
        </DropdownItem>
        <DropdownItem
          toggle={false}
          onClick={(e) => handleClick('UNANSWERED', 'STATUS', e)}
        >
          <input
            id={`dropdownItemUNANSWERED`}
            type="checkbox"
            checked={filters['STATUS'] === 'UNANSWERED'}
            onChange={(e) => handleClick('UNANSWERED', 'STATUS', e)}
            style={{ marginRight: '5px' }}
          />
          Não Respondidas
        </DropdownItem>
      </DropdownMenu>
    </Dropdown>
  );
};
